import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import AlwaysOnOfferPropertyCancellationPolicies from './AlwaysOnOfferPropertyCancellationPolicies'
import ConnectionCancellationPolicies from './ConnectionCancellationPolicies'
import useOfferAvailableRates from 'hooks/useOfferAvailableRates'

const CancellationPoliciesLoadingIndicator = styled(LoadingIndicator)`
  padding: 0;
`

interface Props {
  offerId: string
  uniqueKey?: string
  checkInDate?: string
  checkOutDate?: string
  occupants?: Array<App.Occupants>
  cancellationPolicy?: App.OfferCancellationPolicy
  fetching?: boolean
  hideNonRefundableMessage?: boolean
  textLinkFormat?: boolean
  hideIndicator?: boolean
  useDynamicCancellationPolicies?: boolean
  timezoneOffset?: number
  hideExcludesFlights?: boolean
  offerType?: string
}

function TAOCancellationPolicies(props: Props) {
  const {
    offerId,
    checkInDate,
    checkOutDate,
    uniqueKey,
    occupants,
    fetching,
    cancellationPolicy,
    hideNonRefundableMessage,
    textLinkFormat,
    hideIndicator,
    useDynamicCancellationPolicies,
    timezoneOffset,
    hideExcludesFlights,
    offerType,
  } = props

  const offerAvailableRates = useOfferAvailableRates(offerId, {
    checkIn: checkInDate,
    checkOut: checkOutDate,
    rooms: occupants,
  })

  const fetchingData = fetching || !!offerAvailableRates?.fetching
  const pkgAvailableRate = offerAvailableRates?.rates?.find(rate => rate.packageUniqueKey === uniqueKey)

  return <>
    {!useDynamicCancellationPolicies && cancellationPolicy &&
      <AlwaysOnOfferPropertyCancellationPolicies
        cancellationPolicy={cancellationPolicy}
        checkInDate={checkInDate}
        propertyTimezoneOffset={timezoneOffset}
        hideNonRefundableMessage={hideNonRefundableMessage}
        textLinkFormat={textLinkFormat}
      />}
    {useDynamicCancellationPolicies && fetchingData && !hideIndicator && (
      <CancellationPoliciesLoadingIndicator visible={fetchingData} opaque inline />
    )}
    {useDynamicCancellationPolicies && !fetchingData && pkgAvailableRate?.cancellationPolicies && (
      <ConnectionCancellationPolicies
        cancellationPolicy={cancellationPolicy}
        cancellationPolicies={pkgAvailableRate.cancellationPolicies}
        checkIn={checkInDate}
        hideNonRefundableMessage={hideNonRefundableMessage}
        textLinkFormat={textLinkFormat}
        hideExcludesFlights={hideExcludesFlights}
        offerType={offerType}
      />
    )}
  </>
}

function mapStateToProps(state: App.State, ownProps: Props) {
  return {
    fetching: !!(state.offer.offersLoading[ownProps.offerId]),
  }
}

export default connect(mapStateToProps)(TAOCancellationPolicies)
